// extracted by mini-css-extract-plugin
export default {"input":"createBlock_input__-CdYL","btn":"createBlock_btn__ERCqg","inputBlock":"createBlock_inputBlock__DLHgO"};